import jwt_decode from "jwt-decode";
import { getAccountCodeFromToken, getEmailFromToken, getIsImpersonatedFromToken, getIsInIFrame, getLgSrc, getaccTypeFromToken, } from "./tokenParser";
export class AccountDetails {
    constructor(localStorage, cookieStorage) {
        this.localStorage = localStorage;
        this.cookieStorage = cookieStorage;
    }
    async getAccountCode() {
        return this.getParsedAccountCode();
    }
    async getmfInf() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.accs.mfInf;
        })
            .catch((err) => {
            return false;
        });
    }
    async getParsedAccountCode() {
        let inIframe = getIsInIFrame();
        if (inIframe)
            return await this.accCodeFromJwtToken();
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.accTyp === "EQ"
                ? jsonObj.accs.eqAccID
                    ? jsonObj.accs.eqAccID
                    : jsonObj.eqAccID
                : jsonObj.accs.coAccID
                    ? jsonObj.accs.coAccID
                    : jsonObj.coAccID;
        })
            .catch(async (err) => {
            return await this.accCodeFromJwtToken();
        });
    }
    async getCipFlag() {
        if (await this.localStorage.get("isImpersonated")) {
            return JSON.parse(await this.localStorage.get("isImpersonated"));
        }
        else {
            const jwtToken = await this.getJWTToken();
            if (jwtToken) {
                try {
                    const decoded_token = await jwt_decode(jwtToken);
                    return decoded_token
                        ? getIsImpersonatedFromToken(decoded_token)
                        : false;
                }
                catch (e) {
                    return false;
                }
            }
            else {
                return false;
            }
        }
    }
    async getLoginSrc() {
        const jwtToken = await this.getJWTToken();
        if (jwtToken) {
            try {
                const decoded_token = await jwt_decode(jwtToken);
                return decoded_token ? getLgSrc(decoded_token) : "";
            }
            catch (e) {
                return "";
            }
        }
        else {
            return "";
        }
    }
    async isNonPoaClient() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.accs.cdslAuToSl;
        })
            .catch(async (err) => (await this.cookieStorage.get("isNonPOA"))
            ? JSON.parse(await this.cookieStorage.get("isNonPOA"))
            : false);
    }
    async getEmailId() {
        if (getIsInIFrame())
            return this.getEmailFromJWTToken();
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.accs.eml ? jsonObj.accs.eml : "";
        })
            .catch(async (err) => {
            return this.getEmailFromJWTToken();
        });
    }
    async getAccTyp() {
        if (getIsInIFrame())
            return this.getaccTypeFromToken();
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            if (data)
                return JSON.parse(data);
            return Promise.reject("acc_data not found");
        })
            .then((jsonObj) => {
            return (jsonObj === null || jsonObj === void 0 ? void 0 : jsonObj.accTyp) || (jsonObj === null || jsonObj === void 0 ? void 0 : jsonObj.accType);
        })
            .catch(async (err) => {
            return this.getaccTypeFromToken();
        });
    }
    async getUserID() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.userID || jsonObj.userId;
        })
            .catch((err) => {
            return this.getNameFromJwtToken();
        });
    }
    async getEmpOrDependent() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            var _a;
            return (_a = jsonObj === null || jsonObj === void 0 ? void 0 : jsonObj.accs) === null || _a === void 0 ? void 0 : _a.empOrDependent;
        })
            .catch((err) => {
            return "";
        });
    }
    async getPhoneNo() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.mrgAccDts.phNos || jsonObj.accs.mobile;
        })
            .catch((err) => {
            return [];
        });
    }
    async getAccPhoneNo() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.accs.mobile;
        })
            .catch((err) => {
            return [];
        });
    }
    async getEqAccName() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.accs.eqAccName;
        })
            .catch(async (err) => {
            return await this.getNameFromJwtToken();
        });
    }
    async getCoAccName() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.accs.coAccName;
        })
            .catch(async (err) => {
            return await this.getNameFromJwtToken();
        });
    }
    async getProducts() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.prds;
        })
            .catch((err) => {
            return [];
        });
    }
    async getOrderTypes() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.ordTypes;
        })
            .catch((err) => {
            return [];
        });
    }
    async getValidity() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.val;
        })
            .catch((err) => {
            return [];
        });
    }
    async getpanAadhaarLinked() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.panAadhaarLinked === "true";
        })
            .catch((err) => {
            return null;
        });
    }
    async prefAccTyp() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.prefAccTyp;
        })
            .catch((err) => {
            return "";
        });
    }
    async eqAccID() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.eqAccID;
        })
            .catch((err) => {
            return "";
        });
    }
    async coAccID() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.coAccID;
        })
            .catch((err) => {
            return "";
        });
    }
    async getAccountMrgSts() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.mrgSts;
        })
            .catch((err) => {
            return null;
        });
    }
    async getPrfid() {
        return await this.localStorage
            .get("acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.accs.prfId;
        })
            .catch((err) => {
            return null;
        });
    }
    async getGuestId() {
        return await this.localStorage
            .get("guest_acc_data")
            .then((data) => {
            return JSON.parse(data);
        })
            .then((jsonObj) => {
            return jsonObj.guestId;
        })
            .catch((err) => {
            return null;
        });
    }
    isUserLoggedIn() {
        let userLoggedIn = false;
        const jwtToken = window.localStorage.getItem("jwt_token");
        if (jwtToken !== undefined && jwtToken !== null && jwtToken !== "") {
            userLoggedIn = true;
        }
        else
            userLoggedIn = false;
        return userLoggedIn;
    }
    async getJWTToken() {
        let inIframe = getIsInIFrame();
        if (inIframe)
            return await this.localStorage.get("sales_jwt_token");
        try {
            return (await this.cookieStorage.get("jwt_token"))
                ? await this.cookieStorage.get("jwt_token")
                : await this.localStorage.get("jwt_token");
        }
        catch (_a) {
            return "";
        }
    }
    async getNameFromJwtToken() {
        const jwtToken = await this.getJWTToken();
        if (jwtToken) {
            try {
                const decoded_token = jwt_decode(jwtToken);
                return decoded_token ? decoded_token.username : "";
            }
            catch (e) {
                return "";
            }
        }
        else {
            return "";
        }
    }
    async accCodeFromJwtToken() {
        const jwtToken = await this.getJWTToken();
        if (jwtToken) {
            try {
                const decoded_token = jwt_decode(jwtToken);
                return decoded_token ? getAccountCodeFromToken(decoded_token) : "";
            }
            catch (e) {
                return "";
            }
        }
        else {
            return "";
        }
    }
    async getEmailFromJWTToken() {
        try {
            const jwtToken = await this.getJWTToken();
            const decoded_token = await jwt_decode(jwtToken);
            return getEmailFromToken(decoded_token);
        }
        catch (e) {
            return "";
        }
    }
    async getaccTypeFromToken() {
        const jwtToken = await this.getJWTToken();
        try {
            const decoded_token = await jwt_decode(jwtToken);
            return getaccTypeFromToken(decoded_token);
        }
        catch (e) {
            return "";
        }
    }
}
